/* Generated from _mychapters/shared/similarity.core.js by build.mjs. Do not edit here. */
(function () {
/* myChapters similarity: groups ideas that describe the same concept in different words
   ("A magical wizard library" ~ "Enchanted wizard library"). Pure functions, no dependencies.
   This file is the single source: build.mjs wraps it for the Worker (ES module), the admin
   dashboard and the theme (window.MCSimilarity). Edit here, then run `node build.mjs`. */

const STOP = new Set((
  'a an and are as at be been but by can could did do does for from had has have he her his how i if in into is it its ' +
  'just like love lovely me more most my no not of on one or our out over please really so some such than that the their ' +
  'them then there these they this those to too up us very want wants was we were what when where which while who why will ' +
  'with would you your yours also maybe perhaps something anything thing things idea ideas kind sort type style look looks ' +
  'book books nook nooks kit kits diy miniature miniatures mini tiny little small cute cosy cozy beautiful nice pretty great ' +
  'build building built make made model models world worlds scene scenes shelf insert version inspired full lots lot bit ' +
  'new old big large huge detailed detail details include included including inside outside'
).split(' '));

/* Words that mean the same thing for product demand. Keys are the canonical token. */
const CANON = {
  magic: 'magic magical magically magician magicians enchanted enchanting enchantment enchantress wizard wizards wizardry witch ' +
    'witches witchy witchcraft sorcerer sorcerers sorcery sorceress spell spells spellbook spellbooks potion potions alchemy ' +
    'alchemist alchemists mage mages arcane mystic mystical warlock hogwarts',
  library: 'library libraries librarian librarians archive archives archivist bibliotheque scriptorium',
  bookshop: 'bookshop bookshops bookstore bookstores bookseller booksellers booksellers',
  cafe: 'cafe cafes coffee coffeeshop coffeehouse espresso tearoom tearooms teashop teahouse',
  bakery: 'bakery bakeries baker bakers patisserie boulangerie cake cakes pastry pastries',
  greenhouse: 'greenhouse greenhouses glasshouse glasshouses conservatory conservatories orangery hothouse',
  garden: 'garden gardens gardening botanical botanic plant plants flower flowers floral blossom blossoms',
  florist: 'florist florists flowershop',
  victorian: 'victorian dickensian edwardian regency',
  japanese: 'japanese japan tokyo kyoto osaka ramen izakaya sakura shrine torii',
  chinese: 'chinese china pagoda',
  gothic: 'gothic goth haunted haunting spooky creepy eerie vampire vampires ghost ghosts ghostly',
  halloween: 'halloween pumpkin pumpkins',
  christmas: 'christmas xmas festive yuletide yule santa noel advent',
  winter: 'winter wintry snow snowy snowfall frost frosty',
  street: 'street streets alley alleys alleyway alleyways lane lanes',
  town: 'town towns village villages city cities market marketplace square',
  sea: 'sea seas ocean oceans seabed underwater undersea mermaid mermaids coral harbour harbor coastal coast beach seaside',
  lighthouse: 'lighthouse lighthouses',
  space: 'space astronomy astronomer observatory telescope stars starry planet planets galaxy cosmic cosmos astronaut',
  museum: 'museum museums gallery galleries exhibit exhibition',
  curiosity: 'curiosity curiosities cabinet antique antiques oddities',
  workshop: 'workshop workshops atelier workbench tinker tinkerer inventor inventors clockmaker clockmakers watchmaker',
  steampunk: 'steampunk clockwork gears cogs',
  study: 'study studies office desk writer writers scholar scholars',
  bedroom: 'bedroom bedrooms attic attics loft lofts',
  kitchen: 'kitchen kitchens',
  train: 'train trains railway railways station stations locomotive',
  tavern: 'tavern taverns pub pubs inn inns alehouse bar bars',
  restaurant: 'restaurant restaurants bistro diner',
  shop: 'shop shops store stores boutique boutiques shopfront storefront emporium',
  forest: 'forest forests woodland woodlands woods wood tree trees treehouse',
  fairy: 'fairy fairies fae faerie pixie pixies elf elves elven',
  dragon: 'dragon dragons wyrm wyvern',
  castle: 'castle castles tower towers fortress palace',
  medieval: 'medieval mediaeval middle ages',
  paris: 'paris parisian french france',
  london: 'london londoner',
  rain: 'rain rainy raining rainfall storm stormy',
  night: 'night nightime nighttime moon moonlit moonlight midnight',
  cat: 'cat cats kitten kittens',
  music: 'music musical musician instrument instruments piano violin',
  toy: 'toy toys toyshop toymaker',
  sweet: 'sweet sweets sweetshop candy confectionery chocolate chocolatier'
};

const CANON_MAP = (() => {
  const m = Object.create(null);
  for (const [k, words] of Object.entries(CANON)) for (const w of words.split(' ')) if (w) m[w] = k;
  return m;
})();

function stem(w) {
  if (CANON_MAP[w]) return w;
  if (w.length > 5 && w.endsWith('ies')) return w.slice(0, -3) + 'y';
  if (w.length > 4 && w.endsWith('es') && /(sh|ch|x|ss)es$/.test(w)) return w.slice(0, -2);
  if (w.length > 3 && w.endsWith('s') && !w.endsWith('ss')) return w.slice(0, -1);
  return w;
}

/** Lower-case, strip accents and punctuation, drop stop words, map synonyms to one canonical token. */
function tokens(text, limit) {
  if (!text) return [];
  const words = String(text)
    .normalize('NFKD').replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/book\s+(shop|store)/g, 'bookshop')
    .replace(/coffee\s+shop/g, 'coffeeshop')
    .replace(/tea\s+(room|shop|house)/g, 'tearoom')
    .replace(/flower\s+shop/g, 'flowershop')
    .replace(/tree\s+house/g, 'treehouse')
    .replace(/sweet\s+shop/g, 'sweetshop')
    .replace(/toy\s+shop/g, 'toyshop')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim().split(/\s+/);
  const out = [];
  for (let w of words) {
    if (w.length < 3 || STOP.has(w) || /^\d+$/.test(w)) continue;
    w = stem(w);
    if (STOP.has(w)) continue;
    const c = CANON_MAP[w] || w;
    out.push(c);
    if (limit && out.length >= limit) break;
  }
  return out;
}

function tokenSet(text, limit) {
  return new Set(tokens(text, limit));
}

function overlap(a, b) {
  let n = 0;
  for (const t of a) if (b.has(t)) n++;
  return n;
}

function jaccard(a, b) {
  if (!a.size && !b.size) return 0;
  const i = overlap(a, b);
  return i / (a.size + b.size - i);
}

/**
 * How well an idea matches a concept (0..1).
 * idea: {title, description, world}; concept: {title, keywords: [], summary, world}
 * Mostly "how much of the concept's signature words appear in the idea", weighted to the idea's title.
 */
function conceptScore(idea, concept) {
  const C = tokenSet([concept.title || '', (concept.keywords || []).join(' ')].join(' '));
  if (!C.size) return 0;
  const T = tokenSet(idea.title || '');
  const A = new Set([...T, ...tokenSet(idea.description || '', 80)]);
  const hitsAll = overlap(C, A);
  if (!hitsAll) return 0;
  const cover = hitsAll / C.size;
  const titleCover = overlap(C, T) / C.size;
  const precision = T.size ? overlap(C, T) / T.size : 0;
  let s = 0.45 * cover + 0.35 * titleCover + 0.2 * precision;
  const wi = idea.world, wc = concept.world;
  if (wi && wc && wi !== 'Something else' && wc !== 'Something else') s += wi === wc ? 0.08 : -0.05;
  return Math.max(0, Math.min(1, Math.round(s * 1000) / 1000));
}

/** Symmetric similarity between two ideas (0..1), used to spot repeated requests that aren't grouped yet. */
function ideaSimilarity(a, b) {
  const ta = tokenSet(a.title || ''), tb = tokenSet(b.title || '');
  const fa = new Set([...ta, ...tokenSet(a.description || '', 60)]);
  const fb = new Set([...tb, ...tokenSet(b.description || '', 60)]);
  let s = 0.7 * jaccard(ta, tb) + 0.3 * jaccard(fa, fb);
  if (a.world && b.world && a.world === b.world && a.world !== 'Something else') s += 0.06;
  return Math.max(0, Math.min(1, Math.round(s * 1000) / 1000));
}

/** Best matches for an idea among concepts: [{concept, score}] sorted, above minScore. */
function rankConcepts(idea, concepts, minScore = 0.34, max = 5) {
  return concepts
    .map((c) => ({ concept: c, score: conceptScore(idea, c) }))
    .filter((r) => r.score >= minScore)
    .sort((x, y) => y.score - x.score)
    .slice(0, max);
}

/**
 * Group ideas into clusters of repeated requests (single link). Words are weighted by how rare they are in
 * this pool of ideas, so a shared distinctive word ("lighthouse") counts for more than a common one
 * ("library"). Similarity = weight of shared words / weight of the smaller idea. Returns clusters, largest first.
 */
/* Setting, style and mood words describe the world rather than what it is ("Victorian toy shop" vs "Victorian
   bookshop"), so they count half when spotting repeated requests. */
const MODIFIERS = new Set(['victorian', 'japanese', 'chinese', 'medieval', 'paris', 'london', 'sea', 'winter', 'night', 'rain',
  'christmas', 'halloween', 'town', 'street', 'forest', 'magic', 'gothic', 'steampunk', 'fairy', 'garden']);

function clusterIdeas(ideas, threshold = 0.42) {
  const n = ideas.length, parent = ideas.map((_, i) => i);
  const find = (i) => (parent[i] === i ? i : (parent[i] = find(parent[i])));
  const sets = ideas.map((i) => {
    const m = new Map();
    for (const t of tokenSet(i.title || '')) m.set(t, 1);
    for (const t of tokenSet(i.description || '', 30)) if (!m.has(t)) m.set(t, 0.5);
    return m;
  });
  const df = new Map();
  for (const s of sets) for (const t of s.keys()) df.set(t, (df.get(t) || 0) + 1);
  const w = (t, f) => f * (MODIFIERS.has(t) ? 0.5 : 1) * Math.log((n + 1) / ((df.get(t) || 0) + 0.5));
  const mass = sets.map((s) => [...s].reduce((a, [t, f]) => a + w(t, f), 0));
  for (let i = 0; i < n; i++) {
    for (let j = i + 1; j < n; j++) {
      const small = Math.min(mass[i], mass[j]);
      if (!small) continue;
      let shared = 0;
      for (const [t, f] of sets[i]) if (sets[j].has(t)) shared += w(t, Math.min(f, sets[j].get(t)));
      let sim = shared / small;
      if (ideas[i].world && ideas[i].world === ideas[j].world && ideas[i].world !== 'Something else') sim += 0.05;
      if (sim >= threshold) parent[find(i)] = find(j);
    }
  }
  const groups = new Map();
  ideas.forEach((idea, i) => {
    const r = find(i);
    if (!groups.has(r)) groups.set(r, []);
    groups.get(r).push(idea);
  });
  return [...groups.values()].sort((a, b) => b.length - a.length);
}

/** Suggested matching keywords for a new concept, from the ideas grouped into it. */
function suggestKeywords(ideas, max = 8) {
  const counts = new Map();
  for (const i of ideas) for (const t of tokenSet([i.title, i.description].join(' '), 60)) counts.set(t, (counts.get(t) || 0) + 1);
  return [...counts.entries()].sort((a, b) => b[1] - a[1]).slice(0, max).map((e) => e[0]);
}

const MCSimilarityAPI = { tokens, tokenSet, jaccard, conceptScore, ideaSimilarity, rankConcepts, clusterIdeas, suggestKeywords };

window.MCSimilarity = MCSimilarityAPI;
})();
